import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<'nav'>;
export const MenuWrapper = ({ children }: Props) => {
    return <div className="menu__wrapper">{children}</div>;
};
